import type { ReactNode } from 'react';

import { BlockHostProvider, type BlockHost } from '@/shared/page';
import type { AnyScreenAction } from '@/shared/screen';

import { actionSpec, useActionRunner, type ActionSpec } from './actions';
import { useRouterNavigation } from './navigation';

/**
 * Hospedeiro dos blocos na tela oficial (09 §10.1): a intenção do bloco vira a ação do manifesto,
 * rodada pelo mesmo executor do cabeçalho (confirmação, Desfazer, erro). Precisa de um
 * `ActionRunnerProvider` acima.
 */
export function ScreenBlockHost({ actions, children }: { readonly actions: readonly (AnyScreenAction | ActionSpec)[]; readonly children: ReactNode }) {
  const runner = useActionRunner();
  const nav = useRouterNavigation();
  const host: BlockHost = {
    surface: 'screen',
    run: (actionId, input) => {
      const entry = actions.find((candidate) => ('action' in candidate ? candidate.action.id : candidate.id) === actionId);
      if (!entry) {
        if (import.meta.env.DEV) throw new Error(`o hospedeiro não conhece a ação ${actionId}`);
        return undefined;
      }
      return runner.run('action' in entry ? entry : actionSpec(entry), input);
    },
    navigate: (to, options) => nav.to(to, options?.search ? { search: { ...options.search } } : undefined),
  };
  return <BlockHostProvider host={host}>{children}</BlockHostProvider>;
}
